export const NAV = {
  logo: 'nav-logo',
  home: 'nav-home',
  services: 'nav-services',
  caseStudies: 'nav-case-studies',
  about: 'nav-about',
  contact: 'nav-contact',
  ctaButton: 'nav-cta-book-call',
  mobileToggle: 'nav-mobile-toggle',
};

export const HERO = {
  primaryCta: 'hero-primary-cta',
  secondaryCta: 'hero-secondary-cta',
  headline: 'hero-headline',
};

export const CTA = {
  primary: 'section-cta-primary',
  secondary: 'section-cta-secondary',
};

export const CONTACT = {
  section: 'contact-section',
  form: 'contact-form',
  name: 'contact-name-input',
  email: 'contact-email-input',
  company: 'contact-company-input',
  phone: 'contact-phone-input',
  budget: 'contact-budget-select',
  message: 'contact-message-input',
  submit: 'contact-submit-button',
  success: 'contact-success-message',
  error: 'contact-error-message',
};

export const FOOTER = {
  root: 'footer-root',
  logo: 'footer-logo',
};
